import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const FAQS = [
  {
    q: "Do you provide alteration services?",
    a: "Yes. Boutique and alteration services are available for both men and women, including garment fitting and modification. Message us on WhatsApp to discuss what you need.",
  },
  {
    q: "Do you provide home delivery?",
    a: "Yes. Free home delivery is available within a 5 km radius on orders above ₹1,500. Send us your order and location on WhatsApp and we'll confirm the details.",
  },
  {
    q: "What footwear brands are available?",
    a: "Paragon, Walkaroo, Flite and VKC are among the footwear brands available at our store. Availability of specific styles and sizes can be confirmed on WhatsApp.",
  },
  {
    q: "What innerwear brands are available?",
    a: "Rupa, Dollar, Jockey and Ramraj are among the innerwear brands available. Reach out to check current stock and sizes.",
  },
  {
    q: "Do you sell products for both men and women?",
    a: "Yes. The store carries ladies' and gents' garments — daily wear, casual and traditional — along with footwear, innerwear, bags, accessories and home-comfort essentials.",
  },
  {
    q: "Do you have festive offers?",
    a: "Yes. On every festival — Diwali, Ugadi and more — we offer a flat 30% discount on garments and a flat 10% discount on footwear. Check the banner at the top of this page or message us on WhatsApp for today's offers.",
  },
  {
    q: "Where is the store located and when is it open?",
    a: "Om Sri Sri Collection is at Ashram Kitchen Road, Udayapura, Kanakapura Main Road, Bangalore – 560082. We're open every day from 8:00 AM to 10:00 PM. Tap Get Directions for Google Maps, or call / WhatsApp us on +91 88252 82510.",
  },
  {
    q: "Which languages can I speak with you in?",
    a: "You're welcome to speak with us in Hindi, Kannada, English, Rajasthani or Haryanvi — whichever is most comfortable for you.",
  },
];

export const Faq = () => (
  <section id="faq" className="py-16 sm:py-24 lg:py-32">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <Eyebrow>Good to Know</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-cream text-balance">
          Frequently asked questions.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`faq-${i}`}
              data-testid={`faq-accordion-item-${i + 1}`}
              className="border border-white/10 rounded-2xl bg-charcoal-card px-6 data-[state=open]:border-gold/40 transition-colors duration-300"
            >
              <AccordionTrigger className="text-left font-display text-lg sm:text-xl font-medium text-cream hover:text-gold hover:no-underline py-5 [&[data-state=open]]:text-gold">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-cream/60 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
